var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartialCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.7083,
    height: 17,
    rx: 5.66667,
    fill: "#FFC600",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90049 8.7H7.96449V10.5H7.43649V6.3H8.90049C9.68649 6.3 10.1485 6.762 10.1485 7.5C10.1485 8.238 9.68649 8.7 8.90049 8.7ZM7.96449 8.196H8.93049C9.36249 8.196 9.60249 7.95 9.60249 7.5C9.60249 7.05 9.36249 6.804 8.93049 6.804H7.96449V8.196Z",
    fill: "#FFC600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialCheckbox);
export default __webpack_public_path__ + "static/media/partial_checkbox.b0ffa506d7f874e2c29eb39ef8ec92ff.svg";
export { ForwardRef as ReactComponent };